import { keepPreviousData, useQuery } from '@tanstack/react-query';
import Fetch from '../../../../../../core/util/core/Fetch';
import config from '../../../../../config/config';

const endpoint = config.endpoints.backend + 'governanceroom/sectors/census/themes/';

// Ano null: os anos da cidade ainda estão carregando; a consulta espera para não buscar duas vezes.
const isYearReady = year => year !== null && year !== undefined;

// Fetch.post não rejeita em erro HTTP: devolve o corpo { message }.
async function post(path, body, isValid) {
    const response = await Fetch.post(endpoint + path, body);
    if (!isValid(response)) {
        throw new Error(response?.message || 'Erro ao buscar dados do Censo.');
    }
    return response;
}

/**
 * Variáveis do tema ({ code, description }), com a descrição do dicionário do IBGE.
 */
export const useCensusThemeVariables = theme =>
    useQuery({
        queryKey: ['census-theme-variables', theme],
        queryFn: () => post('variables', { theme }, Array.isArray),
        enabled: Boolean(theme),
        staleTime: Infinity
    });

/**
 * Valor de uma variável do tema em cada setor censitário da cidade: { year, values: [{ id, value }] }.
 */
export const useCensusThemeValues = (theme, cityId, year, variable) =>
    useQuery({
        queryKey: ['census-theme-values', theme, cityId, year, variable],
        queryFn: () =>
            post(
                'values',
                { theme, city_id: cityId, year: year || null, variable },
                response => Array.isArray(response?.values)
            ),
        enabled: Boolean(theme && cityId && variable) && isYearReady(year),
        // Ao trocar de variável, o mapa mantém as cores anteriores até chegarem as novas.
        placeholderData: keepPreviousData
    });

/**
 * Soma das variáveis do tema na cidade ou nos setores informados: { year, hasData, variables: [{ code, description, value }] }.
 */
export const useCensusThemeSummary = (theme, cityId, year, sectorIds = null) =>
    useQuery({
        queryKey: ['census-theme-summary', theme, cityId, year, sectorIds],
        queryFn: () =>
            post(
                'summary',
                { theme, city_id: cityId, year: year || null, sector_ids: sectorIds },
                response => Array.isArray(response?.variables)
            ),
        enabled: Boolean(theme && cityId) && isYearReady(year),
        // Ao trocar de área, o painel mantém os números anteriores até chegarem os novos.
        placeholderData: keepPreviousData
    });
